import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import StudentMediaItemStatsTable from 'modules/media/components/StudentMediaItemStatsTable';

import { useStudentMediaItemStats } from 'modules/media/hooks/stats';

const StudentMediaItemStatsPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const { from } = queryString.parse(location.search) || {};

  const { courseId, studentId, mediaId } = useParams();

  const { mediaStats, loading, error, onGetXlsxData } = useStudentMediaItemStats({
    courseId,
    studentId,
    mediaId,
  });

  const onGoBack = useCallback(() => {
    if (from) {
      history.push(from);
    } else {
      history.push(`/${courseId}/students/${studentId}/media-stats`);
    }
  }, [history, courseId, studentId, from]);

  return (
    <Box>
      <BackButton onGoBack={onGoBack} subtitle={intl.formatMessage({ id: 'student.mediaStats' })} title={mediaStats?.student?.name} />
      <StudentMediaItemStatsTable mediaStats={mediaStats} loading={loading} error={error} onGetXlsxData={onGetXlsxData} />
    </Box>
  );
};

export default StudentMediaItemStatsPage;
